import { PdaAccessToken } from "src/app/pda/utils/Service/pda-auth.service";

export class PdaGeneraAvvisoRequest{
  token!: PdaAccessToken;
  codiceUfficio!: string;
  singoliVersamenti!: PdaSingoloVersamento[];
};

export class PdaSingoloVersamento{
  importo!: string;
  causale!: string;
  datiRiscossioneSpecifici!: string;
}
